import React from 'react';
import './ServicesPage.css'

/* Componet */
import HeaderPage from '../../components/Header/HeaderPage';
import Footer from '../../components/Footer/Footer';
import ParticleBackground from "../../components/ParticlesBg/ParticleBackground";
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';
import Accordion from './Accordion'


/* Multi idioma */
import { FormattedMessage } from 'react-intl';

const Services = () => {
  return (
    <div>

      <HeaderPage />

      <ParticleBackground />

      <main className="service-page">
      <section className="servicios" id="servicios">
        <h2 className="heading">
            <FormattedMessage
                id='services'
                defaultMessage='My Expertise'
            />
        </h2>
        <div className="row">
            <div className="columns" data-aos="fade-up" data-aos-delay="200">
                <i className="fas fa-drafting-compass"></i>
                <h3>
                    <FormattedMessage
                        id='design'
                        defaultMessage='Frontend Development & UI/UX Design'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='design-info'
                        defaultMessage='Crafting intuitive and visually appealing interfaces that engage users and communicate brand identity clearly. I design clean, modern layouts with strong attention to responsive design, color harmony, and accessibility — ensuring each product looks and feels professional on any device.'
                    />
                </p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="300">
                <i className="fas fa-laptop"></i>
                <h3>
                    <FormattedMessage
                        id='development'
                        defaultMessage='Full-Stack Web Development'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='development-info'
                        defaultMessage='Building robust and scalable web applications from front to back. Proficient in React, Next.js, and Node.js to deliver responsive, high-performance websites with smooth user interactions and clean architecture. Every project I build prioritizes usability, maintainability, and seamless cross-device experience.'
                    />
                </p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="400">
                <i className="fas fa-chart-line"></i>
                <h3>
                    <FormattedMessage
                        id='marketing'
                        defaultMessage='Blockchain & Smart Contract Development'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='marketing-info'
                        defaultMessage='Developing secure blockchain solutions and decentralized applications (DApps). Skilled in Solidity, Web3.js, and NFT/DeFi systems, I design and deploy smart contracts with a focus on security, scalability, and transparency. I’ve built and audited production-level contracts on Ethereum and BSC networks.'
                    />
                </p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="500">
                <i className="fas fa-wrench"></i>
                <h3>
                    <FormattedMessage
                        id='maintenance'
                        defaultMessage='Backend & API Development'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='maintenance-info'
                        defaultMessage='Creating secure, efficient, and scalable server-side systems. Experienced in Node.js, Express, and Python, I focus on building RESTful APIs, handling complex data flows, and integrating third-party services to ensure reliability and performance.'
                    />
                </p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="600">
                <i className="fas fa-search"></i>
                <h3>
                    <FormattedMessage
                        id='seo'
                        defaultMessage='Mobile App Development'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='seo-info'
                        defaultMessage='Creating cross-platform mobile applications using React Native. I ensure smooth performance and consistent design across iOS and Android, focusing on responsive UI and reliable data synchronization with backend APIs .'
                    />
                </p>
            </div>
            <div className="columns" data-aos="fade-up" data-aos-delay="700">
                <i className="fas fa-tachometer-alt"></i>
                <h3>
                    <FormattedMessage
                        id='optimization'
                        defaultMessage='Web Optimization & Performance'
                    />
                </h3>
                <p>
                    <FormattedMessage
                        id='optimization-info'
                        defaultMessage='Improving website speed, SEO, and overall user experience. I apply best practices in caching, image compression, and code optimization to enhance performance and search ranking, ensuring that users stay engaged and conversion rates improve.'
                    />
                </p>
            </div>
        </div>
    </section>

        {/* <section className="site-services">
          
        </section> */}

        <section className="preguntas">
          <h2 className="heading">
            <FormattedMessage
              id='services-questions'
              defaultMessage='Questions for me'
            />
          </h2>
          <div className="accordion-container">
            <Accordion
              title={<FormattedMessage
                id='services-questions-1'
                defaultMessage='What is the orientation of your service?'
              />}
              content={<FormattedMessage
                id='services-questions-p1'
                defaultMessage='I love taking on projects that challenge me to learn and grow. Every task is a chance to expand my skills — and I always keep my focus on creating results that make my clients genuinely satisfied.'
              />}
              dataAos="fade-right"
              dataAosDelay="300"
            />

            <Accordion
              title={<FormattedMessage
                id='services-questions-2'
                defaultMessage='Are you available for long-term relocation or extended work journeys?'
              />}
              content={<FormattedMessage
                id='services-questions-p2'
                defaultMessage='Not right now. I’ve built a life that fits perfectly with remote work, and for the past few years, it’s given me both flexibility and focus to do my best work from anywhere.'
              />}
              dataAos="fade-left"
              dataAosDelay="300"
            />

            <Accordion
              title={<FormattedMessage
                id='services-questions-3'
                defaultMessage='Are you available to work in overlapping time zones?'
              />}
              content={<FormattedMessage
                id='services-questions-p3'
                defaultMessage='Definitely! Working with clients across different time zones has been part of my rhythm since I started remote work. It’s taught me how to communicate clearly and stay connected no matter where we are in the world.'
              />}
              dataAos="fade-right"
              dataAosDelay="300"
            />

            <Accordion
              title={<FormattedMessage
                id='services-questions-4'
                defaultMessage=' What type of employment do you usually prefer?'
              />}
              content={<FormattedMessage
                id='services-questions-p4'
                defaultMessage='I usually take on contract or SES-based roles because I enjoy the diversity of projects. But I’m also excited by the idea of a full-time position that lets me grow alongside a great team.'
              />}
              dataAos="fade-left"
              dataAosDelay="300"
            />

          </div>
        </section>
      </main>


      <ScrollToTop />

      <Footer />

    </div>
  )
}
export default Services;